'use client';
import { ParsedUrlQuery } from 'querystring';

import { useEffect, useMemo } from 'react';

import { useSearchParams } from 'next/navigation';

import clean from '@utils/cleanObject';
import { paramsToObject } from '@components/views/utils';

export const useOverrideLinkHref = ({
  elementId,
  destination = 'sizi-arayalim-talep-formu',
  queryParams,
}: {
  elementId: string;
  destination?: string;
  queryParams: object;
}) => {
  const searchParams = useSearchParams();
  const query: ParsedUrlQuery = useMemo(() => {
    return paramsToObject(searchParams?.entries());
  }, [searchParams]);
  useEffect(() => {
    const searchParams = new URLSearchParams();
    const params = clean({ ...query, ...queryParams });
    Object.keys(params).forEach((key) => searchParams.append(key, params[key]));
    const newURLQuery = searchParams.toString();

    const InsiderBadgeElement = document.querySelector(`#${elementId}`);

    InsiderBadgeElement?.setAttribute('href', `/${destination}?${newURLQuery}`);
  }, [destination, query, elementId, queryParams]);
};
